import React, { useEffect, useState } from "react";
import SOURCES from "../../../utils/constants";
import CommonForm from "../../global/form";
import { Form } from "antd";
import CommonDialog from "../../global/dialog";
import usePost from "../../../services/usePost";
import { MSG_USER } from "../../../utils/message";
import { message } from "antd";
import { handleYupValidationErrors } from "../../../utils/functions";

const AddUser = ({ paymentPlans, showForm, setShowForm, getUsers }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const { callApi: addUser } = usePost({
    endpoint: `admin/add-user`,
  });

  const getPlans = () => {
    if (Array.isArray(paymentPlans) && paymentPlans.length > 0) {
      return paymentPlans?.map((item) => ({
        label: item.planName,
        value: item._id,
      }));
    }
    return [];
  };

  const handleSubmit = async () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log("Form values:", values);
        try {
          setLoading(true);
          const userAdd = await addUser(
            {
              email: values.email,
              password: values.password,
              confirmPassword: values.confirmPassword,
              name: values.name,
              phone: values.phone,
              company: values.company,
              paymentStatus: true, // Make sure this is true because we are adding from the admin side
              paymentPlanId: values.choosePlan,
            },
            MSG_USER.SAVE,
            true
          );
          if (userAdd && userAdd.status === SOURCES.HTTP_CODE_200) {
            setShowForm(false);
            message.success("User added successfully");
            getUsers();
          }
          //   setErrors({});
        } catch (err) {
          console.log(err);
          message.error("Something went wrong");
          setLoading(false);
        } finally {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Validation failed", err);
      });
  };

  const formData = [
    {
      label: "Name",
      name: "name",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "text",
      placeholder: "Enter your full name.",
      required: true,
      message: "Name is required.",
    },
    {
      label: "Company",
      name: "company",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "text",
      placeholder: "Enter company name.",
      required: true,
      message: "Company name is required.",
    },
    {
      label: "Phone",
      name: "phone",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "number",
      placeholder: "Enter your phone number.",
      required: true,
      message: "Phone number is required.",
    },
    {
      label: "Email",
      name: "email",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "email",
      placeholder: "Enter your email.",
      required: true,
      message: "Email is required.",
    },
    {
      label: "Password",
      name: "password",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "password",
      placeholder: "Enter password.",
      required: true,
      message: "Password is required.",
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "password",
      placeholder: "Enter confirm password.",
      required: true,
      message: "Confirm password is required.",
    },
    {
      label: "Choose Plan",
      name: "choosePlan",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Choose plan.",
      required: true,
      message: "Plan is required.",
      span: 24,
      options: getPlans(),
    },
  ];

  return (
    <CommonDialog
      title="Add User"
      description={"Fill the form to add a new user."}
      open={showForm}
      setOpen={setShowForm}
      onOk={() => handleSubmit()}
      isConfirmButtonLoading={loading}
      onCancel={() => setShowForm(false)}
    >
      <CommonForm
        data={formData}
        // onSubmit={(values) => console.log(values)}
        className="mt-4"
        layoutType="vertical"
        form={form}
      />
    </CommonDialog>
  );
};

export default AddUser;
